import { useEffect, useRef, useState } from "react";
import { useLocation , useHistory} from "react-router-dom";
import PDFTemplate from "./pdfTemplate";
import axios from "axios";
import qs from "qs";
import dataProvider from "../../../../services/dataProvider";
import { EDIT_MEMBERS_ROUTE, MEMBER_OVERVIEW_ROUTE } from "../../dashboard-routes";
import { DASHBOARD_ROUTE } from "../../../../routes";

const MemberProfile = () => {
    let baseState = {
        fullName: "",
        licenseNumber: "",
        role: [""],
        issue: "",
        expiry: "",
        mobileNumber: "",
        secondaryMobileNumber: "",
        email: "",
        secondaryEmail: ""
    };

    const location = useLocation();
    const [memberData, setMemberData] = useState(baseState);
    const [memberID, setMemberID] = useState("");
    const pageRef = useRef();
    const [isDownloading, setIsDownloading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        //console.log(location);
        if(location.state?.memberData?.data) {
            setMemberData( location.state.memberData.data);
            setMemberID(location.state.memberData.id)
        } else{
            history.replace({
                pathname: DASHBOARD_ROUTE + MEMBER_OVERVIEW_ROUTE
            });
        }
        
    }, []);

    function print() {
        //console.log(pageRef.current.innerHTML);

        //console.log(PDFTemplate(memberData));
        setIsDownloading(true);
        var data = qs.stringify({
            html_string: PDFTemplate(memberData)
        });

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "generatePdfFromHtml",
            responseType: 'arraybuffer',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'Accept': 'application/pdf'
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                setIsDownloading(false);
                const url = window.URL.createObjectURL(new Blob([response.data], {type:"application/pdf"}));
                const link = document.createElement("a");
                //console.log(url);
                link.href = url;
                link.setAttribute("download", "memberData.pdf"); 
                document.body.appendChild(link);
                link.click();
            })
            .catch(function (error) {
                console.error(error);
                setIsDownloading(false);
            });
    }

    function editProfile() {
        history.push({
            pathname: DASHBOARD_ROUTE + EDIT_MEMBERS_ROUTE ,
            state: {
                member_id: memberID,
            },
        });
    }

    return (
        <div id="member-profile">
            <div className="container-fluid p-0">
                <div className="d-flex align-items-center flex-row card p-4 no-radius">
                    <div className="m-0 h5">Member Profile</div>
                    <div className="flex-fill"></div>
                    <button className="btn btn-primary text-white" onClick={editProfile} >Edit</button>

                    <button className="d-flex align-items-center ms-2 btn btn-outline border bg-light text-2" onClick={print}>
                        Download PDF
                        {
                            isDownloading && (
                                <div className="spinner-border spinner-border-sm ms-3 text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            )
                        }
                    </button>
                </div>
            </div>
            <div className="container-fluid p-3">
                <div className="card p-3">
                    <div className="row">
                        <div className="col-lg">
                            <div className="text-nowrap my-3">
                                <span className="h5">{memberData.fullName}</span>
                            </div>
                            <div className="text-nowrap my-3">
                                <span>License Number:</span>
                                <span className="text-2 ms-2">{memberData.licenseNumber}</span>
                            </div>
                            <div className="text-nowrap my-3">
                                <span>Issue:</span>
                                <span className="text-2 ms-2">{memberData.issue}</span>
                            </div>
                            <div className="text-nowrap my-3">
                                <span>Email Address:</span>
                                <span className="text-2 ms-2">{memberData.email}</span>
                            </div>
                        </div>
                        <div className="col-lg">
                            <div className="text-nowrap my-3">
                                <span>License Status:</span>
                                {memberData.licenseStatus === "Active" ? (
                                    <span className="ms-2 text-success">Active</span>
                                ) : (
                                    <span className="ms-2 text-danger">Not Active</span>
                                )}
                            </div>
                            <div className="text-nowrap my-3">
                                <span>Role:</span>
                                <span className="text-2 ms-2">{memberData.role}</span>
                            </div>
                            <div className="text-nowrap my-3">
                                <span>Expiry:</span>
                                <span className="text-2 ms-2">{memberData.expiry}</span>
                            </div>
                            <div className="text-nowrap my-3">
                                <span>Secondary Email Address:</span>
                                <span className="text-2 ms-2">{memberData.secondaryEmail}</span>
                            </div>
                        </div>
                        <div className="col-lg">
                            <div className="text-nowrap my-3">
                                <span>Mobile Phone:</span>
                                <span className="text-2 ms-2">{memberData.mobileNumber}</span>
                            </div>
                            <div className="text-nowrap my-3">
                                <span>Secondary Mobile Phone:</span>
                                <span className="text-2 ms-2">{memberData.secondaryMobileNumber}</span>
                            </div>
                            <div className="text-nowrap my-3">
                                <span>Subscription Status:</span>
                                {memberData.subscriptionStatus === "Active" ? (
                                    <span className="ms-2 text-success">Active</span>
                                ) : (
                                    <span className="ms-2 text-danger">Not Active</span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MemberProfile;
